import { render, staticRenderFns } from "./ResponseModal.vue?vue&type=template&id=25cd924a&"
import script from "./ResponseModal.vue?vue&type=script&lang=ts&"
export * from "./ResponseModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports